import React from "react";
import { Link } from "react-router-dom";
import { Heart, Star } from "lucide-react";
import { useStore } from "../context/StoreContext";
import { inr } from "../lib/api";

export const ProductCard = ({ product }) => {
  const { toggleWishlist, wishlist, addToCart } = useStore();
  const v = product.variants[0];
  const inWishlist = wishlist.includes(product.slug);
  const discount = v.mrp > v.price ? Math.round(((v.mrp - v.price) / v.mrp) * 100) : 0;

  const quickAdd = (e) => {
    e.preventDefault();
    addToCart({
      product_id: product.id, slug: product.slug, name: product.name,
      variant: v.weight, price: v.price, qty: 1, image: product.images[0], subscription: false,
    });
  };

  return (
    <Link to={`/product/${product.slug}`} data-testid={`product-card-${product.slug}`} className="group block">
      <div className="relative overflow-hidden rounded-xl bg-sand aspect-square mb-4">
        <img
          src={product.images[0]}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {product.best_seller && (
          <span className="absolute top-3 left-3 bg-forest text-cream text-[10px] uppercase tracking-[0.15em] px-2.5 py-1 rounded-full">Best Seller</span>
        )}
        {discount > 0 && (
          <span className="absolute top-3 right-3 bg-gold text-forest text-[10px] font-medium px-2 py-1 rounded-full">{discount}% OFF</span>
        )}
        <button
          onClick={(e) => { e.preventDefault(); toggleWishlist(product.slug, product.name); }}
          data-testid={`wishlist-toggle-${product.slug}`}
          className="absolute bottom-3 right-3 w-9 h-9 rounded-full bg-white/90 flex items-center justify-center hover:bg-white transition-colors"
        >
          <Heart size={16} className={inWishlist ? "fill-gold text-gold" : "text-forest"} />
        </button>
        <button
          onClick={quickAdd}
          data-testid={`quick-add-${product.slug}`}
          className="absolute bottom-0 left-0 right-12 bg-forest/95 text-cream text-xs uppercase tracking-[0.15em] py-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300"
        >
          Quick Add
        </button>
      </div>
      <div>
        <div className="flex items-center gap-1 mb-1">
          {product.rating > 0 ? (
            <>
              <Star size={12} className="fill-gold text-gold" />
              <span className="text-xs text-muted-foreground">{product.rating} ({product.review_count})</span>
            </>
          ) : (
            <span className="text-xs text-muted-foreground">New arrival</span>
          )}
        </div>
        <h3 className="font-serif text-lg text-forest leading-tight group-hover:text-gold transition-colors">{product.name}</h3>
        <p className="text-xs text-muted-foreground mb-2">{product.short_desc}</p>
        <div className="flex items-baseline gap-2">
          <span className="text-forest font-medium">{inr(v.price)}</span>
          {v.mrp > v.price && <span className="text-xs text-muted-foreground line-through">{inr(v.mrp)}</span>}
          <span className="text-xs text-muted-foreground">/ {v.weight}</span>
        </div>
      </div>
    </Link>
  );
};
